<template>
  <multiselect
    :value="value"
    :options="options"
    :placeholder="placeholder"
    :searchable="searchable"
    :multiple="true"
    :close-on-select="closeOnSelect"
    :max-height="maxHeight"
    :disabled="disabled"
    :group-values="grouped ? 'items' : null"
    :group-label="grouped ? 'category' : null"
    :class="multiselectClasses"
    v-bind="$attrs"
    @input="handleInput"
    @search-change="$emit('search-change', $event)"
    @open="$emit('open')"
    @close="$emit('close')"
  >
    <template #noResult>
      <slot name="noResult">
        <span>No results found</span>
      </slot>
    </template>
    <template #noOptions>
      <slot name="noOptions">
        <span>No options available</span>
      </slot>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'ThemedMultiSelect',
  components: {
    Multiselect
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Select options'
    },
    searchable: {
      type: Boolean,
      default: true
    },
    grouped: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    ariaInvalid: {
      type: String,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaRequired: {
      type: String,
      default: null
    }
  },
  computed: {
    multiselectClasses() {
      return this.cn(
        'themed-multiselect',
        this.error && 'themed-multiselect--error',
        this.disabled && 'themed-multiselect--disabled'
      );
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    }
  }
}
</script>
